import { pipe, path, filter, prop, equals, allPass } from 'ramda';

import { activeShopWebreader } from '../../auth/selectors';

export const isReaderOnline = pipe(prop('status'), equals('online'));

export const getReadersOnline = pipe(
  path(['register', 'webReader', 'readers']),
  filter(isReaderOnline),
);

export const getReaderStage = path(['register', 'webReader', 'stage']);
export const getWebreaderPaymentStatus = path(['register', 'webReader', 'paymentStatus']);
export const getExternalPaymentInfo = path(['register', 'webReader', 'externalPayment']);
export const getIsProcessingExternalPayment = path(['register', 'webReader', 'isProcessingExternalPayment']);
export const getIsProcessorMode = allPass([
  activeShopWebreader,
  prop('isContainerApp'),
  getExternalPaymentInfo,
]);

export const getStoredReaderIntentCaptureResult = path(['register', 'webReader', 'readerIntentCaptureResult']);

export const getTotalFromReaderIntentCaptureResult = pipe(
  getStoredReaderIntentCaptureResult,
  prop('total'),
);
